export class RequestListNetworkError extends Error {
	public status: number;

	public constructor(public message: string, public response: Response, status?: number) {
		super(message);
		this.status = status ?? response.status;
	}
}
